import { createContext as t } from "react";
t();
//# sourceMappingURL=index.es21.js.map
